export default __webpack_public_path__ + "8b60946b13251c212cac05b529a81105.woff2";